export default "__VITE_ASSET__C6o3WBV0__"